import './scss/main.scss';
import './scripts/firebase/config';
import './scripts/firebase/auth';
import './scripts/moduls/general';
import './scripts/firebase/controller';
import './scripts/users/list';
import './scripts/users/task';
import './scripts/users/list-controller';

